import { render, staticRenderFns } from "./keyfacts.vue?vue&type=template&id=4d9f231c"
import script from "./keyfacts.vue?vue&type=script&lang=js"
export * from "./keyfacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports